const namespace = "limsds";
//const ApiHost="https://localhost:44332";
const ApiHost="https://EDCWFD19:8888/api";

const SSRSServer="https://dev-ssrs/Reports/Pages/Report.aspx?ItemPath=%2fManufacturing%2fLyondell+LIMSDSv2%2fReports%2fCertified+-+Standard%2fClient%2fPublic%2f";

import AppConfig from "@/_config/application-config";

import childRoutes from "./routes";

import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);

const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  name: "LIMS DS",
  namespace,
  description: null,
  icon: "mdi-domain",
  accentColor: "#000080",
  mainNavEnabled: true,
  topBarEnabled: true,

  settings: {
    version: "1.0.0",

    environment: "DEV",

    scope: "api://c7c08750-61ed-4fe0-ac48-54bbad5b46d0/Read.All",

    clientId: "c7c08750-61ed-4fe0-ac48-54bbad5b46d0",

    authorizeUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",

    redirect_uri: window.location.origin,

    logoutUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080/",

    tokenUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",

    // Start Report
    OutofLimitSampleReport: SSRSServer+"Out+of+Limit+Sample+Report",
    OutofLimitSampleReportScheduled: SSRSServer+"Out+of+Limit+Sample+Report+Scheduled",
    SamplesbyProcessUnitandArea: SSRSServer+"Samples+by+Process+Unit+and+Area",
    SamplesbyProcessUnitandAreaScheduled: SSRSServer+"Samples+by+Process+Unit+and+Area+Scheduled",
    SampleAudit: SSRSServer+"Sample+Audit",
    USPBatchLotAnalysis: SSRSServer+"USP+Batch+Lot+Analysis",
    SampleCountByShiftandDayOfWeek: SSRSServer+"Sample+Count+By+Shift+and+Day+Of+Week",
    TestCountByShiftandDayOfWeek: SSRSServer+"Test+Count+By+Shift+and+Day+Of+Week",
    SampleandTestCountByUnitandArea: SSRSServer+"Sample+and+Test+Count+By+Unit+and+Area",
    TestCountbyUnitandArea: SSRSServer+"Test+Count+by+Unit+and+Area",
    SamplePointViewedCount: SSRSServer+"Sample+Point+Viewed+Count",
    //End Report
    //Start Help
    NewsLetter:"http://teamshare/sites/BS-QRRC%20Client%20TeamShare/mfglab/LIMSDS/How%20To%20Series/How%20To%20Series%20Index.htm",
    HelpPref:"http://teamshare/sites/BS-QRRC%20Client%20TeamShare/mfglab/LIMSDS/Application%20Help%20Files/Preferences.htm",
    HelpSearchByPoint:"http://teamshare/sites/BS-QRRC%20Client%20TeamShare/mfglab/LIMSDS/Application%20Help%20Files/SearchByPoint.htm",
    HelpSearchBySample:"http://teamshare/sites/BS-QRRC%20Client%20TeamShare/mfglab/LIMSDS/Application%20Help%20Files/SearchBySample.htm",
    //End Help
    //Start WebApi
    WAUserId: ApiHost + "/api/CurrentUser",
    WASiteUnitArea: ApiHost + "/api/SiteUnitArea",
    WAPreferenceByUser: ApiHost + "/api/PreferenceByUserID?",
    WAUpdatePreferenceByUser: ApiHost + "/api/UpdatePreferenceByUserID?",
    WASite: ApiHost + "/api/enumsitessecure?",
    WASites: ApiHost + "/api/sites",
    WAUnit: ApiHost + "/api/EnumUnitsSecureV2?",
    WAArea: ApiHost + "/api/EnumAreasV2?",
    SMWAArea: ApiHost + "/api/GetAreaSelectList?",
    WASampleList: ApiHost + "/api/SampleListByPointSecure?",
    WAProduct: ApiHost + "/api/EnumProductIds?",
    WAGroup: ApiHost + "/api/EnumGroups?",
    WASampleList2: ApiHost + "/api/SampleListForSamplesSecure2?",
    WASearchBySampleResult: ApiHost + "/api/ResultTableForSampleList?",
    WASampleListWithDesc: ApiHost + "/api/SampleListByPointSECURE?",
    WASearchByPointResult: ApiHost + "/api/ResultTableBySamplePointListV2?",
    WALabelTemplate: ApiHost + "/api/LabelTemplates?",
    WAPrinter: ApiHost + "/api/Printers?",
    WAWorkFlow: ApiHost + "/api/Workflows?",
    WASampleDetail: ApiHost + "/api/SampleDetail?",
    WASampleDetailDT: ApiHost + "/api/SampleDetailDataTable?",
    WAXmlToJson: ApiHost + "/api/XmlToJson?",
    WAJsonToXml: ApiHost + "/api/JsonToXml?",
    WASampleArrival: ApiHost + "/api/SampleArrivalPointListSECURE?",
    WASamplePointArrival: ApiHost + "/api/SampleListForAreasSECURE?",
    WASavePref: ApiHost + "/api/saveAreaPreferences?",
    WASamples: ApiHost + "/api/Samples?",
    WAPrint: ApiHost + "/api/Print?",
    WAProductList: ApiHost + "/api/GetProductList?",
    WASamplePoints: ApiHost + "/api/SamplePoints?",
    WALoginSample: ApiHost + "/api/LoginSample?",
    WATestSchedule: ApiHost + "/api/TestSchedule?",
    WAListOfAnalysis: ApiHost + "/api/ListOfAnalysis?",
    WASaveFav: ApiHost + "/api/SaveFavorite?",
    WAFavList: ApiHost + "/api/FavoriteList?",
    WAFavUpdateDelete: ApiHost + "/api/FavoriteUpdateAndDelete?",
    WAMUPreference: ApiHost + "/api/ManageUserPreference?",
    WAUserByEmail: ApiHost + "/api/GetUserByEmail?",
    //End WebApi
    
    env_color_dev: { r: 96, g: 125, b: 139, a: 1 },
    env_color_stg: { r: 38, g: 166, b: 154, a: 1 },

    navigation: [
        { text: 'Search Samples', link: '/limsds/Search-By-Sample', icon: 'mdi-magnify'},
        { text: 'Search Samples By Points', link: '/limsds/Search-By-Point', icon: 'mdi-magnify-plus' },
        { text: 'Recent Sample Arrivals', link: '/limsds/sample-arrival', icon: 'mdi-test-tube' },
        { text: 'Recent Collected Ponits', link: '/limsds/sample-points-arrival', icon: 'mdi-cup' },
        { text: 'Submit Sample', link: '/limsds/submit-sample', icon: 'mdi-note-plus', roles: ['submitter'] },
        { text: 'Submit Sample Sapphire', link: '/limsds/submit-sample-Sapphire', icon: 'mdi-plus-circle', roles: ['submitter'] },
        { text: 'Status / Label', link: '/limsds/Sample-Label-Print', icon: 'mdi-printer', roles: ['submitter'] },
        { text: 'Reports', link: '/limsds/Report', icon: 'mdi-file-document' },
        { text: 'Transmission Log', link: '/limsds/Transmission-Log', icon: 'mdi-view-dashboard' },
        { text: 'Preferences', link: '/limsds/Preference', icon: 'mdi-cog' },
        { text: 'Favorite', link: '/limsds/Favorite', icon: ' mdi-star' },
      ],
  },
        
  //ROUTES

  parentRoute: "/limsds",
  defaultRoute: "Overview",
  childRoutes,

  component: () =>
    import(/* webpackChunkName: "limsds-parent" */ "@/apps/limsds/Application.vue"),

  navigation: [
    {
      title: "Overview",
      route: "overview",
      icon: "mdi-hand",
    },
    {
      title: "Submit Sample",
      route: "submit-sample",
      icon: "mdi-help-circle",
    },
    {
      title: "Submit Sample Sapphire",
      route: "submit-sample-Sapphire",
      icon: "mdi-help-circle",
    },
    {
      title: "Sample Arrival",

      route: "sample-arrival",

      icon: "mdi-hammer-wrench",
    },

    {
      title: "Preference",

      route: "Preference",

      icon: "mdi-hammer-wrench",
    },

    {
      title: "Search By Sample",

      route: "Search-By-Sample",

      icon: "mdi-hammer-wrench",
    },
    {
      title: "Search By Point",

      route: "Search-By-Point",

      icon: "mdi-hammer-wrench",
    },
    {
      title: "Sample Label Print",
      route: "Sample-Label-Print",
      icon: "mdi-hammer-wrench",
    },{
      title: "Report",
      route: "Report",
      icon: "mdi-hammer-wrench",
    },
  ],

  store: {

    pageTitle: {
      default: "LIMS DS",
      storageMode: localStorage,
    },

    userDetails: {
      default: {},
      storageMode: localStorage,
    },
    userId: {
      default: {},
      storageMode: localStorage,
    },

    userPreference: {
      default: {},
      storageMode: localStorage,
    },

    saVisited: {
      default: [],
      storageMode: localStorage,
    },
  },
};

export default AppConfig.merge(appConfig);
